<template>
	<div class="blockDuvida">
		<span class="catDuvida" v-html="titulo"></span>
		<ul class="lstDuvidas" v-if="duvidasLoaded">
			<li v-for="duvida in duvidas" :key="duvida.id">
				<router-link :to="'/duvidas/' + slug + '/' + duvida.slug"><i class="fas fa-angle-right"></i> {{ duvida.titulo }}</router-link>
			</li>
		</ul>
		<span class="loading" v-else>
			<img src="@/assets/loading.gif" />
		</span>
		<router-link class="vermais" :to="'/duvidas/' + slug">Ver mais desta categoria</router-link>
	</div>
</template>

<script>
export default {
	name: 'BlockDuvida',
	props: ['titulo', 'limit', 'duvidas', 'slug'],
	computed: {
		duvidasLoaded() {
			return this.$store.getters.duvidasLoaded;
		},
	},
};
</script>

<style lang="scss">
@import './../assets/sass/reset';
.blockDuvida {
	position: relative;
	min-height: 190px;
	.loading {
		position: absolute;
		top: 40px;
		left: 0;
		min-height: 150px;
		width: 100%;
		background: rgba(255, 255, 255, 0.6);
		img {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 30px;
		}
	}
}
.catDuvida {
	min-height: 40px;
	font-size: 1.2rem;
	font-family: $neosans;
	text-transform: uppercase;
	color: $azulEscuro;
	display: block;
	padding: 10px;
	// margin: 0 0 10px;
	border-bottom: 1px dotted #ccc;
}
.lstDuvidas {
	font-family: Arial, Helvetica, sans-serif;
	font-size: 0.85rem;
	margin: 0 0 10px;
	li {
		// margin: 0 0 10px;
		border-bottom: 1px dotted #ccc;
		a {
			display: block;
			padding: 20px 10px;
			transition: 0.3s;
			text-decoration: none;
			color: rgba(#000000, 0.7);
			&:hover {
				background: #eee;
			}
		}
	}
}
.vermais {
	display: block;
	padding: 10px;
	font-family: Arial, Helvetica, sans-serif;
	font-style: italic;
	font-size: 0.7rem;
	color: $azulClaro;
	transition: 0.3px;
	text-decoration: none;
	&:hover {
		opacity: 0.4;
	}
}
</style>
